export default __webpack_public_path__ + "static/media/mad.5ded1ac8.jpg";